export class Validator {
    static required = x => {
        if(!x) return 'Ce champ est requis';
    };

    static int = x => {
        if(isNaN(x)) return 'Doit être numérique';
    };

    static min = val => x => {
        if(!x || x.length < val) return `Minimum ${val} caractères`;
    };

    static max = val => x => {
        if(!x || x.length > val) return `Maximum ${val} caractères`;
    };

    static email = x => {
        let emailRegex = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)
        if(!emailRegex.test(x)) return 'Doit être un e-mail';
    };

    static password = x => {
        if(!x || !x.match(/^(?=.*[a-zA-Z])(?=.*[0-9])/i)) return 'Doit contenir au moins une lettre et un chiffre'
    };

    static sameAs = val => x => {
        if(x !== val) return 'Les mots de passe ne sont pas identiques'
    };

    static build= (values, validators) => {
        const errors = {};
        Object.keys(validators).forEach(f => {
            const validations = validators[f];
            validations.forEach(v => {
                const error = v(values[f]);
                if(error) errors[f] = error;
            })
        });
        return errors;
    }
}


// WEBPACK FOOTER //
// ./src/core/Validator.js